import { render, staticRenderFns } from "./PosLayoutGrid.vue?vue&type=template&id=6039d440&scoped=true"
import script from "./PosLayoutGrid.vue?vue&type=script&lang=js"
export * from "./PosLayoutGrid.vue?vue&type=script&lang=js"
import style0 from "./PosLayoutGrid.vue?vue&type=style&index=0&id=6039d440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039d440",
  null
  
)

export default component.exports